//@flow

declare var PHP_API_ENDPOINT: string;

import { handleResponse } from "../handle-response";

let headers = new Headers();
headers.append("Accept", "application/json");
headers.append("Content-Type", "application/json");

export class StripeService {

  static createPaymentIntent({order, paymentMethod, callbackStripe}, callback) {
    // console.log("----------createPaymentIntent------------", order.status === "USER_FILLED" &&
    //   paymentMethod.configuration.deposit !== 100
    //     ? true
    //     : false)
    fetch(`${PHP_API_ENDPOINT}/stripe/payment_intent`, {
      method: "POST",
      headers,
      body: JSON.stringify({ orderId : order.id, downPayment : order.status === "USER_FILLED" &&
        paymentMethod.configuration.deposit !== 100
          ? true
          : false,
          callbackStripe : callbackStripe }),
    })
    .then(res => res.json())
    .then(res => callback(res, null))
    .catch(err => callback(err, true));
  }

  static validateCommissions({ order, paymentMethod, stripePaymentMethod, pi, downPayment }, callback) {
    // console.log("downPayment", downPayment)
    // console.log("downPayment---", order.status === "USER_FILLED" &&
    //   paymentMethod.configuration.deposit !== 100
    //     ? true
    //     : false)
    // console.log("----------chargeManageCommissions------------", order.status === "USER_FILLED" &&
    //   paymentMethod.configuration.deposit !== 100
    //     ? true
    //     : false)
    fetch(`${PHP_API_ENDPOINT}/stripe/validate_commissions`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        orderId: order.id,
        method: stripePaymentMethod.id,
        downPayment:
          order.status === "USER_FILLED" &&
          paymentMethod.configuration.deposit !== 100
            ? true
            : false,
        pi : pi
      })
    })
      .then(res => res.json())
      .then(res => callback(res, null))
      .catch(err => callback(err, true));
  }

  static charge({ order, paymentMethod, stripePaymentMethod }, callback) {
    fetch(`${PHP_API_ENDPOINT}/stripe/charge`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        orderId: order.id,
        confId: paymentMethod.configuration.id,
        method: stripePaymentMethod.id,
        downPayment:
          order.status === "USER_FILLED" &&
          paymentMethod.configuration.deposit !== 100
            ? true
            : false
      })
    })
      .then(res => res.json())
      .then(res => callback(res, null))
      .catch(err => callback(err, true));
  }

  static chargeConfirm(
    { id },
    callback
  ) {
    fetch(`${PHP_API_ENDPOINT}/stripe/charge_confirm`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        paiement_id: id,
      })
    })
      .then(res => res.json())
      .then(res => callback(res, null))
      .catch(err => callback(err, true));
  }

  static createCharge(charge) {
    fetch(`${PHP_API_ENDPOINT}/stripe/charge`, {
      method: "PUT",
      headers,
      body: JSON.stringify(charge)
    }).then(handleResponse);
  }
}
